import { Helmet } from 'react-helmet';
import { AiOutlineWarning } from 'react-icons/ai';
import Footer from '../components/Footer';
import Header from '../components/Header';
import '../assets/scss/notFound.scss';

function NotFound() {
  return (
    <main>
      <Helmet>
        <title> Delmiro Mendez e Hijo S.A. | 404 - no encontrado </title>
      </Helmet>
      <Header />
      <section className="error">
        <div className="flex-wrapper">
          <div className="error-content row justify-content-center align-items-center">
            <div className="text-center">
              <div className="text-center error-content_404">
                <h2>404</h2>
                <AiOutlineWarning size="3rem" />
              </div>
              <div className="error-content_message">
                <h2 className="font-bold">Ups 404! No pudimos encontrar lo que estabas buscando.</h2>
                <p>Perdon, pero no encontramos la página que estabas buscando o no existe.</p>
                <a href="/" className="form-button">
                  <button type="button" className="btn btn-primary">
                    Volver al Inicio
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </main>
  );
}

export default NotFound;
